module.exports = __webpack_public_path__ + "static/WhenThePastWasAround7-bc9fc1e932124a291c40f6d0eca143e6.webp";